/**
 * Out of Stock Recommendations - Visitor Recommendations Loader
 * Fetches personalized recommendations and hides section if empty
 */

(function() {
  'use strict';

  const SUPABASE_URL = 'https://bernard-recommender.bernard-legoff-29.workers.dev';

  function init() {
    const sections = document.querySelectorAll('.oos-visitor-recommendations');
    sections.forEach(initSection);
  }

  function initSection(section) {
    const productLimit = parseInt(section.dataset.productLimit, 10) || 8;
    const columnsDesktop = parseInt(section.dataset.columnsDesktop, 10) || 6;
    const columnsTablet = parseInt(section.dataset.columnsTablet, 10) || 3;

    const loadingEl = section.querySelector('[data-loading]');
    const contentEl = section.querySelector('[data-content]');
    const container = section.querySelector('[data-products-container]');

    if (!container) {
      section.style.display = 'none';
      return;
    }

    loadRecommendations({
      section,
      productLimit,
      loadingEl,
      contentEl,
      container
    });
  }

  async function getVisitorId() {
    if (window._rm && typeof window._rm.gv === 'function') {
      try {
        const visitorId = await window._rm.gv();
        if (visitorId) return visitorId;
      } catch (e) {}
    }

    await new Promise(resolve => setTimeout(resolve, 1000));

    if (window._rm && typeof window._rm.gv === 'function') {
      try {
        return await window._rm.gv();
      } catch (e) {}
    }

    return null;
  }

  async function fetchRecommendations(visitorId, limit) {
    const response = await fetch(`${SUPABASE_URL}/functions/v1/recommendations`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ visitorId, limit })
    });

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    return response.json();
  }

  async function loadRecommendations(config) {
    const { section, productLimit, loadingEl, contentEl, container } = config;

    try {
      const visitorId = await getVisitorId();

      if (!visitorId) {
        section.style.display = 'none';
        return;
      }

      const data = await fetchRecommendations(visitorId, productLimit);

      if (!data?.products || data.products.length === 0) {
        section.style.display = 'none';
        return;
      }

      // Render products
      if (window.ProductCardDynamic) {
        window.ProductCardDynamic.renderGrid(container, data.products, {
          impressionContext: 'oos-visitor-recommendations',
          enableHoverImages: true,
          hoverImagesCount: 2,
          showFeedback: false
        });

        // Wrap in carousel slides
        const cards = container.querySelectorAll('product-card');
        cards.forEach(card => {
          const slide = document.createElement('div');
          slide.className = 'carousel__slide';
          card.parentNode.insertBefore(slide, card);
          slide.appendChild(card);
        });
      }

      // Show content, hide loading
      if (loadingEl) loadingEl.style.display = 'none';
      if (contentEl) contentEl.style.display = 'block';

      // Re-initialize theme-scroll
      const themeScroll = container.closest('theme-scroll');
      if (themeScroll && typeof themeScroll.init === 'function') {
        themeScroll.init();
      }

    } catch (error) {
      console.error('[OOS-VisitorReco] Error:', error);
      section.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
